import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as roomTypes from '../../../../room-types'
import * as employee from '../room'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: employee.RESOURCE.payload.dimension.partialId,
      partialId: employee.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Type of Room',
    isOptional: true,
    name: 'Room Type',
    // TODO: change to just 'type'
    partialId: PartialId.Standard.create('room_type'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        roomTypes.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
